import { render, staticRenderFns } from "./_EnoughTokens.vue?vue&type=template&id=5acb081e"
import script from "./_EnoughTokens.vue?vue&type=script&lang=ts"
export * from "./_EnoughTokens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports